const defaultState = {
  data: [],
  webhooks: [],
  loading: false,
  error: false,
};

const alertConfigs = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case 'SET_ALERT_CONFIGS':
      return { ...state, data: action.data };

    case 'UPDATE_ALERT_CONFIG':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case 'REMOVE_ALERT_CONFIG':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'ADD_ALERT_CONFIG':
      return { ...state, data: [...state.data, action.data] };

    case 'ADD_ALERT_CONFIG_WEBHOOK':
      //where data are the ids in format {webhook, alertconfig}
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.alertconfig);
      if (target > -1) {
        try {
          data[target].webhooks = [...(data[target].webhooks || []), action.data];
        } catch {
          throw new Error('Key Error when adding webhook.');
        }
      }

      return { ...state, data };

    case 'REMOVE_ALERT_CONFIG_WEBHOOK':
      //where data are the ids in format {webhook, alertconfig}
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.alertconfig);
      if (target > -1) {
        try {
          data[target].webhooks = data[target].webhooks.filter((d) => d.id !== action.data.id);
        } catch {
          throw new Error('Key Error when adding webhook.');
        }
      }

      return { ...state, data };

    case 'UPDATE_ALERT_CONFIG_WEBHOOK':
      //where data are the ids in format {webhook, alertconfig}
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.alertconfig);
      if (target > -1) {
        try {
          data[target].webhooks = data[target].webhooks.map((d) =>
            d.id === action.data.id ? { ...action.data } : d
          );
        } catch {
          throw new Error('Key Error when update webhook.');
        }
      }

      return { ...state, data };

    case 'SET_ALERT_WEBHOOKS':
      return { ...state, webhooks: action.data };

    case 'UPDATE_ALERT_WEBHOOK':
      data = [...state.webhooks];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, webhooks: data };

    case 'REMOVE_ALERT_WEBHOOK':
      data = [...state.webhooks];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, webhooks: data };

    case 'ADD_ALERT_WEBHOOK':
      return { ...state, webhooks: [...state.webhooks, action.data] };

    case 'SET_ALERT_CONFIGS_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_ALERT_CONFIGS_ERROR':
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default alertConfigs;
